import { render, staticRenderFns } from "./ManageConsolidatedMembers.vue?vue&type=template&id=97d190b6&scoped=true"
import script from "./ManageConsolidatedMembers.vue?vue&type=script&lang=js"
export * from "./ManageConsolidatedMembers.vue?vue&type=script&lang=js"
import style0 from "./ManageConsolidatedMembers.vue?vue&type=style&index=0&id=97d190b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d190b6",
  null
  
)

export default component.exports